import React, { useEffect, useState } from 'react';
import { Navbar, Nav, InputGroup, Col, NavDropdown } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { FaCircleUser } from 'react-icons/fa6'
function Header() {

    const [user, setUser] = useState(null);
    const [email, setEmail] = useState(null);
    const { accounts } = useMsal();

    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const { firstName, lastName, userPrincipalName } = JSON.parse(storedUser);
            setUser(`${firstName} ${lastName}`.toUpperCase());
            setEmail(userPrincipalName);
        }
    }, []);

    return (
        <>

            <Navbar
                bg="light" expand="lg" style={{ padding: '10px' }}>

                <Navbar.Brand href="/">
                    <img src="phmc_keystone.png"
                        width="40"
                        height="40"
                        alt="phmc logo"
                    />

                </Navbar.Brand>

                <span className="d-inline-block" >
                    Pennsylvania
                    <br />
                    <b>Historical & Museum Commission</b>
                </span>
                <Col />
                <Nav className="justify-content-end">
                    <InputGroup>
                        <img src="phmcreports_horizontal.png"
                            height="25"
                            alt="phmc logo"
                        /></InputGroup>
                    <InputGroup>
                        <NavDropdown title={<FaCircleUser size={20} stroke="inverse" strokeWidth=".3" />} align={"end"}  >
                            <NavDropdown.ItemText>Welcome!</NavDropdown.ItemText>
                            <NavDropdown.ItemText> {user && <>{user} </>}</NavDropdown.ItemText>
                            <NavDropdown.ItemText style={{ fontSize: "10px" }}>{email && <>{email}</>}</NavDropdown.ItemText>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#">
                                Logout
                            </NavDropdown.Item>

                        </NavDropdown>
                    </InputGroup>
                    <div></div>
                    {/* <div >

                            <Button variant="primary" onClick={handleShow} className="me-2">
                                <FaUser />
                            </Button>
                            <Offcanvas show={show} onHide={handleClose} placement='end' backdrop="static" scroll='true'>
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title>Welcome! {accounts[0]?.username} </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <a href="">Logout</a>
                                </Offcanvas.Body>
                            </Offcanvas>

                        </div> */}
                </Nav>

            </Navbar >


        </>
    );
}

export default Header;